import PazienteAllegati from "../";

const routes = [
    { name: "PazienteAllegatiList", path: "/paziente/allegati", component: PazienteAllegati.PazienteAllegatiList, meta: { title: "pazienti.lblTitle" } },
    { name: "PazienteAllegatiEdit", path: "/paziente/allegati/edit/:id", component: PazienteAllegati.PazienteAllegatiEdit, meta: { title: "Allegati" } },
];

export default routes;
